import request from "@/config/utils/request";

// 编辑
export function postEditPcConcLease(data) {
  return request({
    url: "/apis/demo/pcconclease/editPcConcLease",
    method: "POST",
    data
  });
}
// 添加
export function postAddPcConcLease(data) {
  return request({
    url: "/apis/demo/pcconclease/savePcConcLease",
    method: "POST",
    data
  });
}
// 删除
export function postDeletePcConcLease(data) {
  return request({
    url: "/apis/demo/pcconclease/removePcConcLease", // 后端接口
    method: "post",
    data
  });
}
// 详情
export function postGetDetail(data) {
  return request({
    url: "/apis/demo/pcconclease/getPcConcLeaseById", // 后端接口
    method: "POST",
    data
  });
}
// 批量查询
export function postGetList(data) {
  return request({
    url: "/apis/demo/pcconclease/listPcConcLeasePage",
    method: "POST",
    data
  });
}
